import Logo from '@shared/components/MedicalSearch/assets/sanitas-logo.svg'

import Marker from '@shared/components/MedicalSearch/assets/marker.svg'
import MarkerHovered from '@shared/components/MedicalSearch/assets/marker_hovered.svg'
import MarkerActive from '@shared/components/MedicalSearch/assets/marker_active.svg'

export const SanitasLogo = Logo

export const MapIcon = Marker
export const MapIconHover = MarkerHovered
export const MapIconActive = MarkerActive
